

























import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import { IFormatParameter, FormatParameter } from '@models';
import CampaignParametersFormTypeBase from '../CampaignParametersFormTypeBase/CampaignParametersFormTypeBase';


@Component
export default class CampaignParametersText extends CampaignParametersFormTypeBase {
  name = 'campaign-parameters-text';

  @Prop({
    type: Object as () => IFormatParameter,
    default: () => null
  })
  formatParameter: IFormatParameter;
  isDeleteAvailable: boolean = false;

  onTextClear(event: any) {
    this.str = this.formatParameter.value;
  }

  get str() {
    return this.local.value;
  }

  set str(str: string) {
    this.update(v => {
      v.file = null;
      v.value = str;
    });

    this.isDeleteAvailable = this.formatParameter.value && this.formatParameter.value != str;
  }

  created() {
    this.isDeleteAvailable = this.formatParameter.value && this.formatParameter.value != this.str;
  }

}
